import {createSlice} from '@reduxjs/toolkit'

export interface SettingsState {
  last_project_id: string | undefined
  last_saved_search: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: SettingsState = {
  last_project_id: undefined,
  last_saved_search: undefined,
  status: 'idle',
  error: null,
}

const settingsSlice = createSlice({
  name: 'settingsSlice',
  initialState,
  reducers: {
    clearLastProject: (state) => {
      state.last_project_id = undefined
    },
    setLastProject: (state, action) => {
      state.last_project_id = action.payload
    },
    clearLastSavedSearch: (state) => {
      state.last_saved_search = undefined
    },
    setLastSavedSearch: (state, action) => {
      state.last_saved_search = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
    //   .addCase(fetchUser.pending, (state) => {
    //     state.status = 'loading'
    //   })
    //   .addCase(fetchUser.fulfilled, (state, action) => {
    //     state.status = 'succeeded'
    //     if (action.payload) {
    //       // @ts-ignore
    //       state.user = action.payload
    //     }
    //   })
    //   .addCase(fetchUser.rejected, (state, action) => {
    //     state.status = 'failed'
    //     state.error = action.payload as string
    //   })
    //   .addCase(updateUserAsncThunk.pending, (state) => {
    //     state.status = 'loading'
    //   })
    //   .addCase(updateUserAsncThunk.fulfilled, (state, action) => {
    //     state.status = 'succeeded'
    //     if (action.payload) {
    //       // @ts-ignore
    //       state.user = action.payload
    //     }
    //   })
    //   .addCase(updateUserAsncThunk.rejected, (state, action) => {
    //     state.status = 'failed'
    //     state.error = action.payload as string
    //   })
    // .addMatcher(apiSlice.endpoints.getUser.matchFulfilled, (state, action) => {
    //   state.status = 'succeeded'
    //   if (action.payload) {
    //     // @ts-ignore
    //     state.user = action.payload
    //   }
    // })
    // .addMatcher(apiSlice.endpoints.getUser.matchRejected, (state, action) => {
    //   state.status = 'failed'
    //   state.error = action.payload as unknown as string
    // })
    // .addMatcher(apiSlice.endpoints.getUser.matchPending, (state) => {
    //   state.status = 'loading'
    // })
  },
})

export const {clearLastProject, setLastProject, clearLastSavedSearch, setLastSavedSearch} =
  settingsSlice.actions
export default settingsSlice.reducer
